let globalVars = {
  useHashInProduction: true,
  useTestAPI: false
}

export { globalVars }
